import api from './api';

const UserService = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/users/', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/users/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getMe: async () => {
    try {
      const response = await api.get('/users/me/');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await api.post('/users/', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`/users/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  partialUpdate: async (id, data) => {
    try {
      const response = await api.patch(`/users/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/users/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updatePassword: async (data) => {
    try {
      const response = await api.put('/users/password/', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  changePassword: async (data) => {
    try {
      const response = await api.put('/users/password/', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default UserService;
